/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels200,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels400,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels401,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels500,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsMutationRequest,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsMutationResponse,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsPathParams,
} from "../../types/individualPaymentOperationsController/PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels.ts";
import { individualPaymentParcelSaveViewModelSchema } from "../individualPaymentParcelSaveViewModelSchema.ts";

export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsPathParamsSchema =
  z.object({
    financialPersonId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels200Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels200>;

/**
 * @description Regra de negócio violada
 */
export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels400Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels401Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels500Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels500>;

export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsMutationRequestSchema =
  z.lazy(
    () => individualPaymentParcelSaveViewModelSchema,
  ) as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsMutationRequest>;

export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsMutationResponseSchema =
  z.lazy(
    () =>
      postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels200Schema,
  ) as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsMutationResponse>;
